import DetailHeaderView from 'app/src/views/components/DetailHeaderView';
import tyroPairingTemplate from './templates/tyro-pairing-header.hbs';

export default class TyroPairingHeaderView extends DetailHeaderView {
  initialize() {
    this.template = tyroPairingTemplate;
    this.ui = {
      buttons: '#header_buttons',
      status: '#pairing_status',
    };
  }

  /**
   * Adds a button to the view.  Overrides the DetailHeaderView method since
   * the template has changed where the buttons are placed.
   *
   * @param {jQuery.Object} button    The button object to be added to the view
   */
  addButton(button) {
    this.ui.buttons.append(button);
  }

  /**
   * Sets the text displayed in the status location
   *
   * @param {String} text     The text to be displayed
   */
  setStatusText(text) {
    this.ui.status.text(text);
  }
}
